module.exports = __webpack_public_path__ + "static/media/24.cd3332fc.webp";